<template>
  <div class="flex flex-col items-center bg-gray-900">
    
    <div v-if='enableTitle' class="flex flex-row py-1 topnav w-full justify-start">
      <img class="w-10 h-10 ml-1 mr-0" src='/img/PBC_logo.svg' />

      <h3 class="ml-4 text-white font-bold text-2xl">playboxcade</h3>

    </div>

    <div v-if='enableSecondaryCta' class="z-60 mb-4 rounded w-full p-4 mx-2 flex flex-col items-center">
        <h1 class="text-white font-bold text-2xl">Create</h1>
        <h2 class="text-blue-300 font-bold text-xl -mt-2">
          Animated
          <span class="text-white font-normal">and</span>
          Interactive
        </h2>
        <h1 class="text-blue-300 font-bold text-white text-2xl">
          Memes
          <span class="text-white font-normal">and</span>
          Animations
        </h1>
    </div>
    <div @click='playAnimation' id="cta-message" class="z-60 px-20 mt-2 content-rotate text-center" :class='animation ? "play-cta-animation" : ""'>
        <h1 class="text-white font-bold text-2xl">Unleash</h1>
        <h1 class="text-white text-xl -mt-3">Your inner</h1>
        <h2 class="text-blue-300 font-bold text-2xl -mt-2">Memelord <span class="text-white font-normal">or</span> Animation Ninja</h2>
    </div>
    

    <div class="flex items-center justify-around overflow-visible pb-4 z-10 -mt-4">

    <svg @click='playAnimation' xmlns="http://www.w3.org/2000/svg" width="120.91" height="139.43" viewBox="0 0 481.91 536.43" class="content-rotate" :class='animation ? "play-cta-animation" : ""'>
      <g id="ninja">
      <path d="M204.39,286.06c2.16-7.45,4.65-14.78,7.29-22.07s5.5-14.5,8.55-21.65a374.29,374.29,0,0,1,20.88-41.85,245.82,245.82,0,0,1,27.46-38.61,163.84,163.84,0,0,1,17.27-17q4.7-3.93,9.79-7.48l2.57-1.73c.87-.57,1.76-1.11,2.64-1.67s1.79-1.07,2.69-1.6l1.36-.78c.46-.26.94-.51,1.42-.76a95.52,95.52,0,0,1,24-8.52A140.36,140.36,0,0,1,355,119.43c16.39-.58,32.38,1,47.9,2.92,7.75.94,15.41,2,22.84,2.79,3.72.4,7.38.75,10.91,1a81.18,81.18,0,0,0,10,0,32.54,32.54,0,0,0,4.07-.54c.57-.13,1.1-.26,1.55-.41a7.27,7.27,0,0,0,1.06-.44c.52-.28.54-.45.35-.36s-.43.37-.44.26,0-.2,0-.45,0-.29,0-.44,0-.35,0-.58a21.37,21.37,0,0,0-.34-3.24,56.22,56.22,0,0,0-2.38-8.65,14.87,14.87,0,1,1,28.06-9.83c.11.32.22.65.31,1l0,.11a83.27,83.27,0,0,1,2.7,13.91,47.23,47.23,0,0,1,.12,8.3c0,.74-.15,1.54-.24,2.31s-.24,1.58-.42,2.42a30.68,30.68,0,0,1-1.53,5.12,28.42,28.42,0,0,1-2.74,5.22,25.61,25.61,0,0,1-4,4.64,28.64,28.64,0,0,1-9.41,5.72,39.56,39.56,0,0,1-8.56,2.08,61.75,61.75,0,0,1-7.46.46,106,106,0,0,1-13.15-.92c-4.15-.52-8.14-1.18-12.07-1.87-7.84-1.39-15.4-2.94-22.9-4.37-15-2.85-29.68-5.29-44.19-5.74a120,120,0,0,0-21.36,1.07,77.87,77.87,0,0,0-19.94,5.55c-3.15,1.41-6.4,3-9.5,4.77s-6.17,3.73-9.16,5.81a147.85,147.85,0,0,0-17.05,14,233.77,233.77,0,0,0-29.28,34.4,366.27,366.27,0,0,0-24,39.09q-5.42,10.16-10.31,20.63c-3.25,7-6.35,14-9.13,21.21h0a.55.55,0,0,1-.71.31A.56.56,0,0,1,204.39,286.06Z" fill="#ff5a5a"/>
      <path d="M293.53,245.72c-11.44-6.25-22.54-13.11-33.45-20.35s-21.54-15-31.83-23.29a289.44,289.44,0,0,1-29.5-27.15,190.42,190.42,0,0,1-13.27-15.76c-2.08-2.8-4.1-5.67-6-8.67s-3.73-6.11-5.43-9.34l-1.24-2.46-1.18-2.51c-.75-1.65-1.42-3.24-2.09-4.9q-2-4.93-3.67-10.1a114.68,114.68,0,0,1-4.79-21.71,88.51,88.51,0,0,1,.32-23.58A76.53,76.53,0,0,1,169,52.23a79.11,79.11,0,0,1,6.7-10.74A86.7,86.7,0,0,1,184,32a99.38,99.38,0,0,1,19.22-14.75A132.69,132.69,0,0,1,224,7.27,179.36,179.36,0,0,1,245.36.73l.31-.08a22.84,22.84,0,1,1,7.82,44.9c-11.23,1.2-22.05,3.55-31.43,7.55S204.91,62.65,199.68,70a42.12,42.12,0,0,0-6.06,12.53,56.45,56.45,0,0,0-2.22,15.1,84.32,84.32,0,0,0,1.44,16.6c.51,2.83,1.15,5.68,1.89,8.53.35,1.41.78,2.87,1.17,4.25l.58,2,.65,2c.91,2.7,2,5.4,3.13,8.1s2.5,5.38,3.9,8a169,169,0,0,0,9.5,15.73,273.53,273.53,0,0,0,23.55,29.62c8.56,9.47,17.69,18.55,27.19,27.29S283.74,237,294,245h0a.46.46,0,0,1,.08.64A.45.45,0,0,1,293.53,245.72Z" fill="#ff5a5a"/>
      <circle cx="191.21" cy="345.22" r="191.21" fill="#fff"/>
      <circle cx="191.21" cy="345.22" r="182.4" fill="#1a202c"/>
      <path d="M59.57,285.45H322.84a0,0,0,0,1,0,0v25.91a54.07,54.07,0,0,1-54.07,54.07H113.65a54.07,54.07,0,0,1-54.07-54.07V285.45a0,0,0,0,1,0,0Z" fill="#ffc064"/>
      <path d="M148.52,335.39a8,8,0,0,1,5.42-7.55c-2.73-5-7.4-8.26-12.71-8.26-8.43,0-15.27,8.28-15.27,18.48s6.84,18.48,15.27,18.48c6.92,0,12.76-5.57,14.63-13.21A8,8,0,0,1,148.52,335.39Z" fill="#1a202c"/>
      <line x1="125.45" y1="319.85" x2="164.99" y2="319.85" fill="none" stroke="#1a202c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="21.79"/>
      <path d="M243.39,335.39a8,8,0,0,1,5.42-7.55c-2.73-5-7.4-8.26-12.71-8.26-8.43,0-15.27,8.28-15.27,18.48s6.84,18.48,15.27,18.48c6.91,0,12.75-5.57,14.63-13.21A8,8,0,0,1,243.39,335.39Z" fill="#1a202c"/>
      <line x1="213.71" y1="319.85" x2="253.25" y2="319.85" fill="none" stroke="#1a202c" stroke-linecap="round" stroke-miterlimit="10" stroke-width="21.79"/>
      <path d="M18.84,285.45H363.58a182.13,182.13,0,0,0-31.26-55.8H50.1A182.13,182.13,0,0,0,18.84,285.45Z" fill="#ff5a5a"/>
      </g>
    </svg>

<div v-if='enableCtaButton' class="mr-2">
            <button @click='onCreate' class="text-center text-md bg-white w-20 h-20 rounded-full font-bold text-gray-900">{{cta}}</button>
            <!-- <button class="text-center text-md bg-white w-20 h-20 rounded-full font-bold text-gray-900">CREATE</button> -->
            <!-- <p class="text-white text-xs ml-2">Create <span class="font-bold">lulz</span> or <br><span class="font-bold">let them play</span></p> -->
          </div>
          <div v-else class="mx-8 mt-10 h-8" >
          </div>

<svg @click='playAnimation' xmlns="http://www.w3.org/2000/svg" width="130.42" height="130.42" viewBox="0 0 382.42 382.42" class="content-rotate2" :class='animation ? "play-cta-animation" : ""'>
  <g id="smile">
  <circle cx="191.21" cy="191.21" r="191.21" fill="#fff"/>
  <circle cx="191.21" cy="191.21" r="182.4" fill="#ffc064"/>
  <path d="M251.36,189.36a8,8,0,0,1-.24-15.94c-2.76-4.74-7.32-7.85-12.48-7.85-8.43,0-15.26,8.28-15.26,18.48s6.83,18.48,15.26,18.48c7,0,12.87-5.68,14.69-13.43A8,8,0,0,1,251.36,189.36Z" fill="#1a202c"/>
  <path d="M66.29,266.94c13.24,23.32,31.51,47.13,56.05,63.48,18,4.7,41,8.35,68.87,8.35s50.82-3.65,68.86-8.35c24.54-16.35,42.81-40.16,56.05-63.48-28.16,5.55-70.2,11.18-124.91,11.18S94.46,272.49,66.29,266.94Z" fill="#700018"/>
  <path d="M191.21,278.12c54.71,0,96.75-5.63,124.91-11.18a303.46,303.46,0,0,0,30-75.73s-21,43.3-154.93,43.3-154.93-43.3-154.93-43.3a303.19,303.19,0,0,0,30,75.73C94.46,272.49,136.5,278.12,191.21,278.12Z" fill="#fff"/>
  <path d="M122.34,330.42a124.25,124.25,0,0,0,137.73,0c-18,4.7-41,8.35-68.86,8.35S140.39,335.12,122.34,330.42Z" fill="#fff"/>
  <path d="M156.49,189.36a8,8,0,0,1-.23-15.94c-2.77-4.74-7.33-7.85-12.49-7.85-8.43,0-15.26,8.28-15.26,18.48s6.83,18.48,15.26,18.48c7,0,12.87-5.68,14.69-13.43A8,8,0,0,1,156.49,189.36Z" fill="#1a202c"/>
  <path d="M263.35,151.36H223.81a10.89,10.89,0,1,1,0-21.78h39.54a10.89,10.89,0,0,1,0,21.78Z" fill="#1a202c"/>
  <path d="M158.61,151.36H119.07a10.89,10.89,0,1,1,0-21.78h39.54a10.89,10.89,0,1,1,0,21.78Z" fill="#1a202c"/>
  </g>
</svg>

    </div>

    </div>
  
</template>
<script>
export default {
  props:{
    cta: {
      type: String,
      default: 'Create'
    },
    parent: {
      type: String,
      default: 'root'
    },
    enableTitle: {
      type: Boolean,
      default: true
    },
    enableSecondaryCta: {
      type: Boolean,
      default: true
    },
    enableCtaButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      animation: true
    }
  },
  methods:{
    onCreate() {
      this.$eventbus.emit('create');
    },
    playAnimation() {
      this.animation = false;
      setTimeout( () => {
      this.animation = true;
      }, 100);
    }
  }
}
</script>

<style scoped>
.content-rotate2 {
transform: rotate(-34deg);
overflow: visible;
}

.content-rotate {
transform: rotate(-7deg);
overflow: visible;
}

@keyframes popup {
  0% {
    transform: translateY(150px) translateX(-200px);
  }
  34% {
    transform: translateY(120px) translateX(-80px);
  }
  37% {
    transform: translateY(70px) translateX(-40px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes crazy {
  0% {
    transform: translateX(100px) rotate(0deg);
  }
  30% {
    transform: translateX(0px) rotate(-34deg);
  }
  80% {
    transform: translateX(0px);
  }
  90% {
  }
  100% {
    transform: rotate(0deg);
  }
}

.play-cta-animation #ninja {
  animation: popup 0.8s 0.0s linear;
}
.play-cta-animation #smile {
  animation: crazy 0.8s 0.0s linear;
  transform-origin: 50% 50%;
}

@keyframes textbounce {
  0% {
    transform: scale(0.4, 0.4) rotate(-7deg);
  }
  30% {
    transform: scale(0.6, 0.6) rotate(-7deg);
  }
  60% {
    transform: scale(0.8, 0.8) rotate(-7deg);
  }
  100% {
    transform: scale(1.0, 1.0) rotate(-7deg);
  }
}
.play-cta-animation#cta-message {
  animation: textbounce 0.2s 0.0s ease;
}
</style>

